import { render, staticRenderFns } from "./IconBox.vue?vue&type=template&id=a6f3c84a&scoped=true"
import script from "./IconBox.vue?vue&type=script&lang=js"
export * from "./IconBox.vue?vue&type=script&lang=js"
import style0 from "./IconBox.vue?vue&type=style&index=0&id=a6f3c84a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f3c84a",
  null
  
)

export default component.exports